
import Vue, { defineComponent } from 'vue';

export default defineComponent({
    name: 'liferecord-svg',
    components: {},
    props: {
        color: {
            type: String,
            default: 'red',
        },
    },
});
